import CONFIG from './CONFIG';

export const buildMediaUrl = (item, route = 'files', download = false) => {
  if (!item?.key) return null;

  const params = new URLSearchParams();
  if (item.expires) params.set('exp', item.expires);
  if (item.signature) params.set('sig', item.signature);
  if (download) params.set('download', 'true');
  if (download && item.fileName) params.set('name', item.fileName);
  const query = params.toString();

  return `${CONFIG.SERVER}/${route}/${item.key}${query ? `?${query}` : ''}`;
};

// Normalize base64 (raw or a data URL) to a data URL.
export const toDataUrl = (value) => {
  if (!value || typeof value !== 'string') return null;
  const compact = value.trim().replace(/\s+/g, '');
  if (!compact || compact === 'null' || compact === 'undefined') return null;
  return compact.startsWith('data:image/') ? compact : `data:image/png;base64,${compact}`;
};

// Channel settings send each image as `<field>Url`, relative to the API, and as
// base64 in `<field>` for older widget builds. The URL lets the browser cache it.
export const channelImageSrc = (settings, field) => {
  const url = settings?.[`${field}Url`];
  if (url && typeof url === 'string') {
    if (/^https?:\/\//i.test(url)) return url;
    return `${CONFIG.SERVER}${url.startsWith('/') ? '' : '/'}${url}`;
  }
  return toDataUrl(settings?.[field]);
};
